export default "__VITE_ASSET__BVG57pWi__"